






























































































































import fileApi from "@/api/fileApi";
import qNotify from "@/common/qNotify";
import Contract, { CONTRACT_CUSTOMER_CONFIRM } from "@/model/contract";
import Property from "@/model/property";
import User from "@/model/user";
import store from "@/store";
import {Component, Mixins} from "vue-property-decorator";
import { namespace } from "vuex-class";
import contractApi from "@/api/contractApi";
import Authority from "@/common/mixins/authority";
// eslint-disable-next-line @typescript-eslint/no-var-requires
var noimage = require("@/assets/images/user-default-image.svg");
const auth = namespace("Auth");
@Component({
  name: "CustomerHomePage",
})
export default class CustomerHomePage extends Mixins(Authority) {
  @auth.Getter
  getCurrentyContract: Contract;

  public isShow = false;
  public errors = {};
  public change = 1;
  public countContractHaveMoveOut = 0;

  public $refs!: {
    avatarImage: HTMLFormElement
  }

  mounted() {
    this.getContractDetail()
  }

  get user() {
    return new User(store.state.Auth.userLogging);
  }
  get avatar() {
    this.change;
    return this.user.avatar ? this.user.avatar.url : noimage;
  }

  get property() {
    return new Property(this.getCurrentyContract.property);
  }

  get subTitle() {
    return this.getCurrentyContract.property
      ? this.getCurrentyContract.property.name +
          " " +
          this.getCurrentyContract.property.room_number
      : "";
  }

  get contracts() {
    const contracts = [];
    this.user.customer_contracts.map((item: Contract) => {
      contracts.push(new Contract(item));
    });
    return contracts;
  }

  public swithContract(contract) {
    if (this.getCurrentyContract.id !== contract.id) {
      store.dispatch("Auth/setUsingContract", contract.id);
      this.getCurrentyContract.is_confirmed ===
        CONTRACT_CUSTOMER_CONFIRM.WAIT &&
        this.$router.push({
          name: "step.intro",
        });
    }
    this.isShow = false;
  }

  public async handleFileUpload(event) {
    let file = event.target.files[0];
    if (!file) {
      return;
    }
    let formData = new FormData();
    formData.append("image", file);
    formData.append("image_type", "User");
    const result = await fileApi.uploadImage(formData);
    if (result.meta.status != 200) {
      qNotify.error({
        text: this.$t(result.meta.message),
      });
    } else {
      this.user.avatar = result.data;
      this.user.avatar_id = result.data.id;
      this.submit();
      this.change++;
    }
  }

  public async submit() {
    const result = await this.user.updateMe();
    if (result.meta.status === 200) {
      qNotify.success({
        text: this.$t("me.updated"),
      });
      this.errors = {};
      // update userLoging
      store.dispatch("Auth/setUser", result.data);
    } else {
      this.errors = result.meta.errors;
      qNotify.error({
        text: result.meta.message,
      });
    }
  }

  public async getContractDetail() {
    const response = await contractApi.detail(this.getCurrentyContract.id);
    if (response) {
      this.countContractHaveMoveOut = response.count_contract_move_outs;
    }
  }

  public removeImage() {
    this.user.avatar_id = null;
    this.user.avatar = null;
    this.$refs.avatarImage.value = null;
    this.submit();
  }
}
